module.exports = __webpack_public_path__ + "static/bg_all.bb596763.png";